// Google Maps JS API is loaded via <script> tag in the layout.
// These helpers wait for the API to be available before returning.

function waitForGoogleMaps(timeoutMs = 10000) {
  return new Promise((resolve, reject) => {
    if (window.google?.maps) {
      resolve()
      return
    }
    let elapsed = 0
    const check = setInterval(() => {
      elapsed += 50
      if (window.google?.maps) {
        clearInterval(check)
        resolve()
      } else if (elapsed >= timeoutMs) {
        clearInterval(check)
        reject(new Error("Google Maps failed to load"))
      }
    }, 50)
  })
}

export async function loadGoogleMaps() {
  await waitForGoogleMaps()
  const { Map } = await google.maps.importLibrary("maps")
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")
  return { Map, AdvancedMarkerElement }
}

export async function loadPlaces() {
  await waitForGoogleMaps()
  return google.maps.importLibrary("places")
}
